import { useAuth } from "@/contexts/AuthContext";
import { useNotify } from "@/contexts/NotifyContext";
import { manualAttendance, queryEvent } from "@/services/EventService";
import axios from "axios";
import { ANGKATAN_PERTAMA, Attendance, AttendanceManualReq, AttendanceManualRes, CommunityEvent, ResponseCode, VerificationMode } from "iasma-datatypes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlumniSearch, SearchOption } from "../directories/AlumniSearch";

export function AbsensiManual({ eventId }: { eventId: number }) {
	const navigate = useNavigate();
	const { setToken, session } = useAuth();
	const { setNotify } = useNotify();

	const [communityEvent, setCommunityEvent] = useState<CommunityEvent | null>(null)
	const [seachSelect, setSearchSelect] = useState<SearchOption | null>(null);
	const [name, setName] = useState<string>("");
	const [graduation, setGraduation] = useState<number>(0);
	const [manualRes, setManualRes] = useState<AttendanceManualRes | undefined>(undefined)

	useEffect(() => {
		async function fetchEvent() {
			try {
				setNotify(null);
				setToken(axios);
				let result: CommunityEvent = await queryEvent(eventId)
				console.log("CommunityEvent", result);
				setCommunityEvent(result)
			} catch (error) {
				setNotify({ title: "Query Event Gagal", error, severity: 'error' });
			}

		}
		fetchEvent()
	}, [eventId])

	const handleSearchSelect = (selected: SearchOption | null) => {
		setSearchSelect(selected)
		if (selected) {
			setName(selected.Name);
			setGraduation(selected.Graduation);
		}
	}

	const handleNameChange = (value: string) => {
		setName(value);
		setSearchSelect(null);
	}

	const handleGraduationChange = (value: string) => {
		setGraduation(Number(value))
		setSearchSelect(null);
	}

	const graduationOptions = Array.from({ length: new Date().getFullYear() - ANGKATAN_PERTAMA + 1 }, (_, i) => ANGKATAN_PERTAMA + i);

	const onSubmitAbsensi = async (e: any) => {
		if (seachSelect || ((graduation > 0) && (name !== ""))) {
			try {
				let data: AttendanceManualReq = {
					OperatorId: session?.User?.Id || 0,
					EventId: eventId,
					Name: seachSelect ? seachSelect.Name : name,
					Graduation: seachSelect ? seachSelect.Graduation : graduation,
					AlumniId: seachSelect ? seachSelect.AlumniId : undefined,
				};

				setNotify(null);
				setToken(axios);
				let result: AttendanceManualRes = await manualAttendance(eventId, data)
				setManualRes(result)
			} catch (error) {
				setNotify({ title: "Absensi Gagal", error, severity: 'error' });
			}
		}
	}

	const headerEvent = () => {
		if (communityEvent) {
			return (
				<div className="mb-3 rounded-lg bg-(--color-background) p-2 text-xs text-(--color-text-secondary)">
					<div className="flex flex-wrap gap-x-1 gap-y-1">
						<span>Acara: <strong className="text-(--color-text)">{communityEvent.Description}</strong>, </span>
						<span>Lokasi: <strong className="text-(--color-text)">{communityEvent.Location}</strong>, </span>
						<span>Komunitas: <strong className="text-(--color-text)">{communityEvent.Community.Name}</strong></span>
					</div>
				</div>
			);
		}
		return <></>;
	}
	const resetForm = () => {
		setManualRes(undefined);
		setSearchSelect(null);
		setName("");
		setGraduation(0);
	}

	const closeButton = () => {
		return (
			<button
				className="w-full rounded-lg bg-(--color-secondary) px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
				onClick={() => navigate(-1)}
			>
				Tutup
			</button>
		)
	}

	if (manualRes) {
		const statusIsSuccess = manualRes.Status === ResponseCode.Success;
		const displayName = seachSelect?.Name || name;
		const displayGraduation = seachSelect?.Graduation || graduation;
		const displayDatetime = manualRes.AttendanceTime || "-";

		const resultRows = [
			{ label: "Nama Alumni", value: displayName || "-" },
			{ label: "Angkatan", value: displayGraduation > 0 ? String(displayGraduation) : "-" },
			{
				label: statusIsSuccess ? "Waktu Kehadiran" : "Status",
				value: statusIsSuccess ? (manualRes.AttendanceTime || "-") : (ResponseCode[manualRes.Status] || "Gagal"),
			},
			...(manualRes.VerifiedBy ? [{ label: "Oleh", value: manualRes.VerifiedBy }] : []),
			...(manualRes.VerificationMode !== undefined && manualRes.VerificationMode !== null ? [{ label: "Dengan Cara", value: VerificationMode[manualRes.VerificationMode] || "-" }] : []),
			{ label: "Pada", value: displayDatetime }
		];

		return (
			<div className="rounded-xl border border-(--color-border) bg-(--color-surface) p-4 text-(--color-text) shadow-sm">
				{headerEvent()}
				<div className="mb-3 flex items-center justify-between gap-3">
					<p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-(--color-text-secondary)">Pencatatan</p>
					<span
						className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusIsSuccess ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}
					>
						{statusIsSuccess ? "Berhasil" : "Gagal"}
					</span>
				</div>

				<div className="grid gap-2 sm:grid-cols-2">
					{resultRows.map((row) => (
						<div key={row.label} className="rounded-lg bg-(--color-background) p-2.5">
							<div className="text-[10px] uppercase tracking-[0.12em] text-(--color-text-secondary)">{row.label}</div>
							<div className="mt-1 text-sm font-medium text-(--color-text) wrap-break-word">{row.value}</div>
						</div>
					))}
				</div>

				<div className="mt-4 grid grid-cols-2 gap-2">
					<button
						type="button"
						className="w-full rounded-lg border border-(--color-border) bg-(--color-surface) px-4 py-2.5 text-sm font-medium text-(--color-text) shadow-sm transition hover:bg-(--color-background)"
						onClick={resetForm}
					>
						Reset
					</button>
					{closeButton()}
				</div>
			</div>
		);
	} else {
		return (<div className="p-4 text-(--color-text) grid gap-2">
			<p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-(--color-text-secondary)">Absensi</p>
			{headerEvent()}
			<div className="space-y-3">
				<div>
					<label className="mb-1.5 block text-sm font-medium text-(--color-text)">Nama</label>
					<AlumniSearch
						onSelected={handleSearchSelect}
						onChangeName={handleNameChange}
						userOnly={false}
					/>
				</div>

				<div>
					<label htmlFor="absensi-graduation" className="mb-1.5 block text-sm font-medium text-(--color-text)">
						Angkatan
					</label>
					<select
						id="absensi-graduation"
						value={graduation || ""}
						onChange={(e) => handleGraduationChange(e.target.value)}
						className="w-full rounded-lg border border-(--color-border) bg-white px-3 py-2 text-sm outline-none transition focus:ring-2 focus:ring-(--color-ring)"
						style={{ color: graduation ? "var(--color-text)" : "var(--color-text-secondary)" }}
					>
						<option value="" disabled hidden style={{ color: "var(--color-text-secondary)" }}>Pilih angkatan</option>
						{graduationOptions.map((year) => (
							<option key={year} value={year} style={{ color: "var(--color-text)" }}>
								{year}
							</option>
						))}
					</select>
				</div>

				{seachSelect &&
					<div className="rounded-lg bg-(--color-background) p-2">
						<span className="block text-[11px] uppercase tracking-wide text-(--color-text-secondary)">Email</span>
						<span className="font-medium text-(--color-text)">{seachSelect.AlumniId}</span>
					</div>
				}

				{seachSelect && seachSelect.Email &&
					<div className="rounded-lg bg-(--color-background) p-2">
						<span className="block text-[11px] uppercase tracking-wide text-(--color-text-secondary)">Email</span>
						<span className="font-medium text-(--color-text)">{seachSelect.Email || "-"}</span>
					</div>
				}

				<button
					type="button"
					onClick={onSubmitAbsensi}
					className="w-full rounded-lg bg-(--color-primary) px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
					disabled={!(graduation > 0 && name.trim() !== "")}
				>
					Catat Kehadiran
				</button>
			</div>
			{closeButton()}
		</div>)
	}
}